import React from "react";
import AgentConversationView from "../AgentConversationView";
import {
  applyCapabilitiesToChatUiPolicy,
  assertConversationCapabilities,
} from "./conversationAdapters";

function ConversationWorkspace({
  capabilities,
  chatUiPolicy,
  allowScheduling,
  allowStop,
  operatorView,
  hideHeader,
  headerActions,
  ...rest
}) {
  assertConversationCapabilities(capabilities, "ConversationWorkspace");
  const effectiveChatUiPolicy = applyCapabilitiesToChatUiPolicy(
    chatUiPolicy,
    capabilities
  );
  const effectiveAllowScheduling =
    typeof allowScheduling === "boolean"
      ? allowScheduling
      : capabilities.canSchedule;
  const effectiveAllowStop =
    typeof allowStop === "boolean" ? allowStop : capabilities.canStop;
  const effectiveOperatorView =
    typeof operatorView === "boolean"
      ? operatorView
      : capabilities.operatorView;

  return (
    <AgentConversationView
      {...rest}
      chatUiPolicy={effectiveChatUiPolicy}
      allowScheduling={effectiveAllowScheduling}
      allowStop={effectiveAllowStop}
      operatorView={effectiveOperatorView}
      hideHeader={hideHeader}
      headerActions={headerActions}
    />
  );
}

export default ConversationWorkspace;
